<template>
    <div class="admin w-screen relative min-h-screen flex flex-col">
        <Head :title="page?.page_title" />
        <Navigation class="!z-[120] pointer-events-auto" :auth="auth" />
        <!-- <div class="absolute top-10 left-1/2 -translate-x-1/2 z-[300] w-full text-center">{{ windowSize }} -- {{ size }}</div> -->
        <div class="admin z-10 pointer-events-auto mx-auto flex flex-wrap justify-center w-screen flex-1">
            <!-- wrap the built-in Transition component -->
            <slot></slot> <!-- pass down slot content -->
        </div>
    </div>
</template>
<script>
import Navigation from '@/components/Navigation.vue';
import { Head, Link } from '@inertiajs/vue3';
export default {
    name: 'authenticatedLayout',
    components: { Head, Link, Navigation },
    props: ['auth']
}
</script>
